/**
 * Imperative API (open / close / toggle) for embeddable widget instances.
 * Registered by VoiceNavWidget when mounted; cleared on unmount.
 */

export type WidgetPanelControls = {
  open: () => void
  close: () => void
  toggle: () => void
}

let active: WidgetPanelControls | null = null

export function setWidgetPanelControls(next: WidgetPanelControls | null) {
  active = next
}

export function getWidgetPanelControls(): WidgetPanelControls | null {
  return active
}
